import { defineStore } from 'pinia'
import axios from '@/utils/axios'

export const useCurrenciesStore = defineStore('currencies', {
  state: () => ({
    list: [],
    lastFetch: 0
  }),

  persist: true,

  actions: {
    async loadCurrencies(force = false) {
      const now = Date.now()
      const isFresh = this.lastFetch && (now - this.lastFetch) < 30 * 60 * 1000

      if (!force && isFresh && this.list.length) {
        return this.list // ← Cache se lo
      }

      try {
        const response = await axios.get('/currencies')
        this.list = response.data.data
        this.lastFetch = now
      } catch (error) {
        console.log(error.message)
      }
      return this.list
    },

    clearCache() {
      this.list = []
      this.lastFetch = 0
    }
  }
})